import React from "react";
import { ChevronDown } from "lucide-react";

const ITEMS = [
  {
    q: "¿Cuánto tarda en llegar mi retrato?",
    a: "El plazo estimado de entrega es de 3 a 5 días laborables desde la confirmación del pago. Si hubiera cualquier incidencia con la foto te avisaremos por email antes de comenzar.",
  },
  {
    q: "¿Puedo devolver el retrato si no me gusta?",
    a: "Al ser un producto totalmente personalizado y elaborado a medida tras tu pedido, está excluido del derecho de desistimiento (art. 103.c RDL 1/2007). Por eso no aceptamos devoluciones ni cambios. Si el producto llega defectuoso o dañado, lo reponemos sin coste.",
  },
  {
    q: "¿Qué calidad debe tener la foto que envíe?",
    a: "Cuanto mejor sea la foto, mejor será el retrato. Recomendamos: buena luz natural, mascota enfocada y centrada, evitar fotos borrosas, oscuras o de muy baja resolución. Si tenemos dudas con tu foto, te contactaremos antes de imprimir.",
  },
  {
    q: "¿Qué formatos de imagen aceptáis?",
    a: "Aceptamos JPG, JPEG, PNG y HEIC. Puedes subir la foto directamente desde el móvil o el ordenador en el paso de pedido.",
  },
  {
    q: "¿Hacéis envíos a toda España?",
    a: "Sí, enviamos a toda la Península con envío incluido en el precio (29,50 €). Para Baleares, Canarias, Ceuta y Melilla escríbenos a artexsala@gmail.com y te indicamos coste y plazo.",
  },
  {
    q: "¿Cómo puedo contactar si tengo dudas?",
    a: "Puedes escribirnos a artexsala@gmail.com o llamarnos al 656 813 536. Te respondemos lo antes posible, normalmente el mismo día laborable.",
  },
];

function Item({ q, a, open, onToggle, idx }) {
  return (
    <div
      className="border-b border-[#e8ddc3] last:border-b-0"
      data-testid={`faq-item-${idx}`}
    >
      <button
        type="button"
        onClick={onToggle}
        className="w-full flex items-center justify-between gap-6 py-5 text-left group"
        aria-expanded={open}
        data-testid={`faq-toggle-${idx}`}
      >
        <span className="font-serif text-lg md:text-xl text-[#1a1816] group-hover:text-[#7a6a48] transition-colors">
          {q}
        </span>
        <ChevronDown
          className={`h-5 w-5 shrink-0 text-[#b59557] transition-transform duration-300 ${
            open ? "rotate-180" : ""
          }`}
        />
      </button>
      <div
        className={`grid transition-all duration-300 ease-out ${
          open ? "grid-rows-[1fr] opacity-100 pb-5" : "grid-rows-[0fr] opacity-0"
        }`}
      >
        <div className="overflow-hidden">
          <p className="text-[15px] leading-relaxed text-[#3a3228] pr-10">{a}</p>
        </div>
      </div>
    </div>
  );
}

export default function FAQ() {
  const [openIdx, setOpenIdx] = React.useState(0);

  return (
    <section
      id="faq"
      className="bg-[#f5f1e8] py-20 md:py-28"
      data-testid="faq-section"
    >
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-12">
          <div className="text-[11px] tracking-[0.25em] uppercase text-[#b59557] mb-3">
            Preguntas frecuentes
          </div>
          <h2 className="font-serif font-medium text-[#1a1816] text-3xl md:text-5xl leading-tight">
            Resolvemos tus dudas
          </h2>
        </div>

        <div className="rounded-2xl border border-[#e8ddc3] bg-white px-6 md:px-8">
          {ITEMS.map((it, i) => (
            <Item
              key={i}
              idx={i}
              q={it.q}
              a={it.a}
              open={openIdx === i}
              onToggle={() => setOpenIdx(openIdx === i ? -1 : i)}
            />
          ))}
        </div>

        <p className="text-center text-sm text-[#7a6a48] mt-8">
          ¿Sigues con dudas? Escríbenos a{" "}
          <a
            href="mailto:artexsala@gmail.com"
            className="text-[#b59557] underline hover:text-[#1a1816]"
            data-testid="faq-contact-email"
          >
            artexsala@gmail.com
          </a>
        </p>
      </div>
    </section>
  );
}
